import React, { useState } from "react";
import { NoAutomation, AutomationList } from "./";
import { AutomationAdd } from "./AutomationAdd";

const AutomationFirstPage = () => {
  const [showAutomation, setShowAutomation] = useState(false);

  return (
    <>
      {/* {!showAutomation ? <NoAutomation /> : <AutomationList />} */}
      <AutomationAdd />
    </>
  );
};

export { AutomationFirstPage };
